<template>
  <vvs-select
    :name="name"
    :label="label"
    :validate="validate"
    :options="$store.getters['addresses/getCities']"
    :disabled="$store.getters['addresses/getCities'].length === 0"
    :loading="loader"
    v-model="proxy"
    @change="onChange"
    @input="onInput"
    :return-object="returnObject"
    :normal-label="normalLabel"
  ></vvs-select>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';

export default {
  name: 'SelectCity',
  mixins: [formControlMixin],
  methods: {
    async getCities() {
      this.loader = true;
      await this.$store.dispatch('addresses/fetchCities', {});
      this.loader = false;
    },
  },
  async mounted() {
    await this.getCities();
  },
};
</script>
